/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register__car__info_box__text = /** @type {(inputs: {}) => string} */ () => {
	return `Wir aktualisieren unsere Datenbank regelmäßig. Wenn Ihr Fahrzeug nicht darin enthalten ist, wählen Sie ein ähnliches Modell oder eines unserer Standardfahrzeuge.`
};

const en_register__car__info_box__text = /** @type {(inputs: {}) => string} */ () => {
	return `We regularly update our database. If your vehicle is not listed, choose a similar model or one of our default vehicles.`
};

const es_register__car__info_box__text = /** @type {(inputs: {}) => string} */ () => {
	return `Actualizamos regularmente nuestra base de datos. Si su vehículo no aparece en la lista, elija un modelo similar o uno de nuestros vehículos predeterminados.`
};

const fr_register__car__info_box__text = /** @type {(inputs: {}) => string} */ () => {
	return `Nous mettons régulièrement à jour notre base de données. Si votre véhicule n’y figure pas, choisissez un modèle similaire ou un de nos véhicules par défaut.`
};

const it_register__car__info_box__text = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiorniamo regolarmente il nostro database. Se il vostro veicolo non è presente nell'elenco, scegliete un modello simile o uno dei nostri veicoli predefiniti.`
};

const nl_register__car__info_box__text = /** @type {(inputs: {}) => string} */ () => {
	return `We werken onze database regelmatig bij. Als je voertuig er niet bij staat, kies dan een vergelijkbaar model of een van onze standaardvoertuigen.`
};

const pt_register__car__info_box__text = /** @type {(inputs: {}) => string} */ () => {
	return `Atualizamos regularmente a nossa base de dados. Se o seu veículo não constar da lista, selecione um modelo semelhante ou um dos nossos veículos predefinidos.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register__car__info_box__text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register__car__info_box__text", locale)
	if (locale === "de") return de_register__car__info_box__text(inputs)
	if (locale === "en") return en_register__car__info_box__text(inputs)
	if (locale === "es") return es_register__car__info_box__text(inputs)
	if (locale === "fr") return fr_register__car__info_box__text(inputs)
	if (locale === "it") return it_register__car__info_box__text(inputs)
	if (locale === "nl") return nl_register__car__info_box__text(inputs)
	return pt_register__car__info_box__text(inputs)
};